import { useDeviceMap } from "../queries/useDeviceMap";

/**
 * Hook to get a human-readable device name from a device code.
 * Consumes the cached device map from useDeviceMap.
 * @param deviceCode The code of the device (e.g., "dm3q", "cheetah")
 * @returns {string} The resolved device name, or the original deviceCode if not found or loading
 */
export const useDeviceName = (deviceCode: string | null | undefined): string => {
    const { data: deviceMap, isLoading } = useDeviceMap();

    if (!deviceCode) return "";
    if (isLoading || !deviceMap) return deviceCode;

    // Exact match
    if (deviceMap[deviceCode]) {
        return deviceMap[deviceCode];
    }

    // Case-insensitive match (if needed, but usually codes are consistent)
    // Given the size of the map, it's better to stick to exact match first.
    // We can add case-insensitive if needed, but for now exact is safer.

    return deviceCode;
};
